import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} id="offer" className="w-full py-24 sm:py-32" style={{
    backgroundColor: '#111118'
  }} data-id="element-125">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-127">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight text-white mb-12" data-id="element-128">
            Reclaim 10+ Hours of Your Life This Week.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} className="text-left max-w-md mx-auto mb-12" data-id="element-129">
          <ul className="space-y-4" role="list" data-id="element-130">
            <li className="flex items-start gap-3" data-id="element-131">
              <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#f97316'
            }} aria-hidden="true" data-id="element-132" />
              <span className="text-lg" style={{
              color: '#d4d4d8'
            }} data-id="element-133">
                25 battle-tested meeting exit scripts
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-134">
              <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#f97316'
            }} aria-hidden="true" data-id="element-135" />
              <span className="text-lg" style={{
              color: '#d4d4d8'
            }} data-id="element-136">
                Pre-meeting filter templates
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-137">
              <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#f97316'
            }} aria-hidden="true" data-id="element-138" />
              <span className="text-lg" style={{
              color: '#d4d4d8'
            }} data-id="element-139">
                Slack/Teams response frameworks
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-140">
              <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#f97316'
            }} aria-hidden="true" data-id="element-141" />
              <span className="text-lg" style={{
              color: '#d4d4d8'
            }} data-id="element-142">
                The 48-hour colleague training system
              </span>
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mb-10" data-id="element-143">
          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-144">
            <span className="text-2xl font-bold line-through" style={{
            color: '#a1a1aa',
            textDecorationColor: '#f97316'
          }} data-id="element-145">
              $97
            </span>
            <span className="text-5xl sm:text-6xl font-black text-white" data-id="element-146">
              $6.39
            </span>
          </div>
          <p className="text-sm" style={{
          color: '#a1a1aa'
        }} data-id="element-147">
            Less than the cost of 5 minutes of your hourly rate.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.45,
        ease: 'easeOut'
      }} data-id="element-148">
          <p className="text-lg mb-10" style={{
          color: '#d4d4d8'
        }} data-id="element-149">
            No fluff. No 300-page book. Just the scripts you need to copy,
            paste, and escape.
          </p>

          <motion.a href="#" className="cta-glow inline-flex items-center justify-center px-10 py-5 text-lg font-bold text-white rounded-lg transition-colors duration-200" style={{
          backgroundColor: '#f97316'
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} data-id="element-150">
            Get The Meeting Mercenary Protocol — $6.39
          </motion.a>
        </motion.div>
      </div>
    </section>;
}